import { render } from "./EmptyLayout.vue?vue&type=template&id=59e45830&ts=true"
import script from "./EmptyLayout.vue?vue&type=script&lang=ts"
export * from "./EmptyLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__